<script>
import CleanLayout from '@/Shared/CleanLayout'
import TextInput from "@/Shared/TextInput";
import FlashMessages from "@/Shared/FlashMessages";
import AuthTabPanel from "./AuthTabPanel";
import AuthTabPane from "./AuthTabPane";

export default {
    metaInfo: { title: Lang.get('employerdashboard::pages/auth/reset_multi_factor_authentication.title') },
    components: {
        AuthTabPane,
        AuthTabPanel,
        FlashMessages,
        TextInput,
        CleanLayout
    },
    props: {
        email: String,
    },
    data() {
        return {
            form: this.$inertia.form({}),
        }
    },
    methods: {
        submit() {
            this.form.post(this.route('nl.employerdashboard.mfa.recover.store'))
        }
    }
}
</script>

<template>
    <clean-layout>
        <main role="main">
            <div class="container">
                <div class="row my-5">
                    <div class="col-12 col-md-10 col-lg-7 mx-auto text-center">
                        <h1 class="h2 font-poppins font-weight-light color-light-blue">
                            {{ Lang.get('employerdashboard::pages/auth/reset_multi_factor_authentication.title') }}
                        </h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-10 col-lg-7 mx-auto">
                        <flash-messages :hideErrors="false"></flash-messages>
                    </div>
                    <div class="col-12 col-md-10 col-lg-7 mx-auto">
                        <div class="card shadow border-0 border-radius-16">
                            <AuthTabPanel>
                                <AuthTabPane
                                    :active="true"
                                    aria-label="employer-tab"
                                    id="employer"
                                >
                                    <template v-if="email">
                                        <p class="font-poppins font-weight-light color-dark-blue">
                                            {{
                                                Lang.get('employerdashboard::pages/auth/reset_multi_factor_authentication.intro')
                                            }}
                                        </p>
                                        <div class="form-group mt-4 mb-4">
                                            <p class="font-poppins color-dark-blue font-weight-medium">
                                                {{
                                                    Lang.get('employerdashboard::shared.recovery_email')
                                                }}:
                                            </p>
                                            <p class="font-weight-light">
                                                {{ email }}
                                            </p>
                                        </div>
                                        <button @click="submit" :disabled="form.processing"
                                                class="btn btn-primary btn-orange font-poppins font-weight-bold color-white border-radius-19 px-5">
                                            {{
                                                Lang.get('employerdashboard::pages/auth/reset_multi_factor_authentication.send_button')
                                            }}
                                        </button>
                                    </template>
                                    <template v-else>
                                        <p class="font-poppins font-weight-light color-dark-blue">
                                            {{
                                                Lang.get('employerdashboard::pages/auth/reset_multi_factor_authentication.no_recovery_mail_known')
                                            }}
                                        </p>
                                    </template>
                                </AuthTabPane>
                            </AuthTabPanel>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </clean-layout>
</template>
